module.exports = new __parcel__URL__("WorkfrontHero.7efae3c8.svg").toString();